import { SvgIcon, SvgIconProps } from '@mui/material';

export const VaultIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="M0 0L11.8989 23.76L23.88 0H0ZM13.3111 4.7691H14.6971V6.14817H13.3111V4.7691ZM10.554 10.2779H9.17168V8.90258H10.554V10.2779ZM10.554 8.21119H9.17168V6.83956H10.554V8.21119ZM10.554 6.14817H9.17168V4.7691H10.554V6.14817ZM12.6461 12.3447H11.2638V10.9656H12.6461V12.3447ZM12.6461 10.2779H11.2638V8.90258H12.6461V10.2779ZM12.6461 8.21119H11.2638V6.83956H12.6461V8.21119ZM12.6461 6.14817H11.2638V4.7691H12.6461V6.14817ZM13.3111 6.83956H14.6971V8.2149H13.3111V6.83956ZM13.3111 10.2816V8.90629H14.6971V10.2816H13.3111Z"
      fill="black"
    />
  </SvgIcon>
);
